import { useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Header from "./bor/header";
import Footer from "./bor/footer";
import Playersmodal from "./bor/playersmodal";
import ArmyModal from "./bor/Armymodal";
import GetServiceNameImagePath from "./bor/GetServiceNameImagePath";
import DistributorProfileModal from "./bor/DistributorProfileModal";
import Topdistributor from "./bor/Topdistributor";
import pointsBGImage from "./../images/Points-box.png"
import pointsBGImageGif from "./../images/score-board-gif.gif"
import cannonBigImage from "./../images/canonbigbottom.png";
import cannonBigGif from "./../images/CanonBig.gif";
import cannonSmallImage from "./../images/cannonsmallbottomnew.png";
import cannonSmallGif from "./../images/canon-catapult-Front-view.gif";
import MatchResult from "./bor/MatchResult";
import { set } from "date-fns";
// import DistributorProfileModal from "./bor/DistributorProfileModal";


function Bor(props) {
    const divRef = useRef(null);
    const [drawersOpen, setDrawersOpen] = useState(true);
    const handleDrawerClose = () => {
        setDrawersOpen(false); // Close both drawers
        setHideDiv({ "display": "none" });

        setTimeout(() => {
            if (divRef.current) {
                // Scroll to the top of the div
                divRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    };



    useEffect(() => {

        setTimeout(() => {
            if (divRef.current) {
                // Scroll to the top of the div
                divRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    }, [])

    let history = useHistory();
    useEffect(() => {
    }, []);

    // Carousal script
    const topCarouselRef = useRef(null);
    const allServicesFilterRef = useRef(null);
    const [allServicesData, setAllServicesData] = useState([]);
    const bottomCarouselRef = useRef(null);
    // const [touchStart, setTouchStart] = useState({ x: 0, scrollLeft: 0 });
    const touchStart = useRef({ x: 0, scrollLeft: 0 }); // Mutable reference to track drag position
    const isDragging = useRef(false); // Mutable reference to track drag state

    const itemSpacing = 20; // Space between carousel items
    const [cookies] = useCookies(['user']);
    const user_id = cookies.user_id;
    const token = cookies.token;
    const points_data = [];
    const my_score = [];
    const [warStartTime, setwarStartTime] = useState(new Date());
    const { state } = props.location;
    const [kdData] = useState(state[0]);
    const [war_id] = useState(state[1]);
    const [error1, setError] = useState(false);
    const [myNormalDistributor, setMyNormalDistributor] = useState({ "astra": 0, "points": 0 });
    const [oppNormalDistributor, setOppNormalDistributor] = useState({ "astra": 0, "points": 0 });
    const [warData, setWarData] = useState({ "status": "success", "war_status": '1', "my_kd_name": "", "my_kd_id": "", "my_a": 0, "my_b": 0, "my_c": 0, "my_total": 0, "my_rm": '', "opp_kd_name": "", "opp_kd_id": "", "opp_a": 0, "opp_b": 0, "opp_c": 0, "opp_total": 0, "opp_rm": '', 'war_end_time': '', 'winner': '' });
    const [myper, setMyper] = useState({ width: "50%" });
    const [oppper, setOppper] = useState({ width: "50%" });
    const [extra, setExtra] = useState('');
    const [myKdText, setMyKdText] = useState('');
    const [myOppText, setMyOppText] = useState('');
    const [lastLink, setLastLink] = useState('');
    const [myBreakup, setMyBreakup] = useState('');
    const [kdBreakup, setKdBreakup] = useState('');
    const [mwBreakup, setMwBreakup] = useState('');
    const timerComponents = [];
    const [points_breakup, setPointsBreakup] = useState('');
    const [my_score_breakup, setMyScoreBreakup] = useState('');
    const [myScore, setMyScore] = useState('');
    const [allPoints, setAllPoints] = useState(null);
    const [hideDiv, setHideDiv] = useState();
    const [isCanonView, setIsCanonView] = useState(false);
    const [canonViewFlag, setCanonViewFlag] = useState(false);
    const [armyViewFlag, setArmyViewFlag] = useState(false);
    const [oppCannonData, setOppCannonData] = useState(null);
    const [myCannonData, setMyCannonData] = useState(null);




    let bgStyleCssObject = {
        backgroundImage: `url(${pointsBGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%"
    }
    let [myPointsBGStyle, setMyPointsBGStyle] = useState(bgStyleCssObject);

    let [oppPointsBGStyle, setOppPointsBGStyle] = useState(bgStyleCssObject);
    let userType = localStorage.getItem("user_type");
    const [showSpan, setShowSpan] = useState(true);
    const [showMySpan, setShowMySpan] = useState(true);
    const [showMyNumber, setshowMyNumber] = useState(false);
    const [showMyNumberOp, setshowMyNumberOp] = useState(false);
    const [showOppPoints, setshowOppPoints] = useState("");
    const [showMyPoints, setshowMyPoints] = useState("");


    // Function to snap to the nearest item
    const snapToNearestItem = (carousel, direction) => {
        const items = carousel.querySelectorAll(".carousel-items");
        const itemWidth = items[0].offsetWidth + itemSpacing; // Account for spacing
        const currentScroll = carousel.scrollLeft;
        const currentIndex = Math.round(currentScroll / itemWidth);
        const targetIndex = direction === "left" ? currentIndex - 1 : currentIndex + 1;
        const boundedIndex = Math.max(0, Math.min(targetIndex, items.length - 1));
        const snapScroll = boundedIndex * itemWidth;

        // Scroll the carousel smoothly to the snapped position
        carousel.scrollTo({
            left: snapScroll,
            behavior: "smooth",
        });

        // Sync the other carousel
        const otherCarousel =
            carousel === topCarouselRef.current
                ? bottomCarouselRef.current
                : topCarouselRef.current;

        const scrollRatio = snapScroll / (carousel.scrollWidth - carousel.clientWidth);
        otherCarousel.scrollTo({
            left: scrollRatio * (otherCarousel.scrollWidth - otherCarousel.clientWidth),
            behavior: "smooth",
        });
        if (direction === "right") {
            setIsCanonView(true);
        } else {
            setIsCanonView(false);
        }
    };

    // Start dragging or swiping
    const handleStart = (event, carousel, isTouch = false) => {
        const pageX = isTouch ? event.touches[0].pageX : event.pageX;

        touchStart.current = {
            x: pageX,
            scrollLeft: carousel.scrollLeft,
        };

        if (!isTouch) {
            isDragging.current = true; // Set dragging state for mouse
        }
    };

    // Handle drag or swipe movement
    const handleMove = (event, carousel, isTouch = false) => {
        if (!isDragging.current && !isTouch) return;  // If not dragging or swiping, do nothing

        const pageX = isTouch ? event.touches[0].pageX : event.pageX;
        const delta = touchStart.current.x - pageX;

        carousel.scrollLeft = touchStart.current.scrollLeft + delta;

        // Sync the other carousel
        const otherCarousel =
            carousel === topCarouselRef.current
                ? bottomCarouselRef.current
                : topCarouselRef.current;

        const scrollRatio = carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth);
        otherCarousel.scrollLeft = scrollRatio * (otherCarousel.scrollWidth - otherCarousel.clientWidth);

        if (!isTouch) event.preventDefault(); // Prevent text selection on desktop
    };

    // End of drag/swipe
    const handleEnd = (event, carousel, isTouch = false) => {
        const pageX = isTouch ? event.changedTouches[0].pageX : event.pageX;
        const delta = touchStart.current.x - pageX;

        // Reset dragging state for desktop
        if (!isTouch) isDragging.current = false;

        // Snap to the nearest item if the drag/swipe exceeds a threshold
        if (Math.abs(delta) > 50) {
            snapToNearestItem(carousel, delta > 0 ? "right" : "left");
        }
    };

    useEffect(() => {
        const carousels = [topCarouselRef.current, bottomCarouselRef.current];

        // Add event listeners for both carousels (touch and mouse)
        carousels.forEach((carousel) => {
            if (!carousel) return;

            // Touch events for mobile
            carousel.addEventListener("touchstart", (e) => handleStart(e, carousel, true));
            carousel.addEventListener("touchmove", (e) => handleMove(e, carousel, true));
            carousel.addEventListener("touchend", (e) => handleEnd(e, carousel, true));

            // Mouse events for desktop
            carousel.addEventListener("mousedown", (e) => handleStart(e, carousel));
            carousel.addEventListener("mousemove", (e) => handleMove(e, carousel));
            carousel.addEventListener("mouseup", (e) => handleEnd(e, carousel));
            carousel.addEventListener("mouseleave", (e) => handleEnd(e, carousel)); // Handle case when dragging exits the carousel
        });

        // Clean up event listeners when component is unmounted
        return () => {
            carousels.forEach((carousel) => {
                if (!carousel) return;

                // Remove touch events
                carousel.removeEventListener("touchstart", (e) => handleStart(e, carousel, true));
                carousel.removeEventListener("touchmove", (e) => handleMove(e, carousel, true));
                carousel.removeEventListener("touchend", (e) => handleEnd(e, carousel, true));

                // Remove mouse events
                carousel.removeEventListener("mousedown", (e) => handleStart(e, carousel));
                carousel.removeEventListener("mousemove", (e) => handleMove(e, carousel));
                carousel.removeEventListener("mouseup", (e) => handleEnd(e, carousel));
                carousel.removeEventListener("mouseleave", (e) => handleEnd(e, carousel));
            });
        };
    }, []);


    //carousal script


    // points drawer
    const [showBackdrop, setShowBackdrop] = useState(false);
    const [isPointsDrawerOpen, setIsPointsDrawerOpen] = useState(false);
    const [oppIP, setOppIP] = useState({});
    const [oppTop, setOppTop] = useState({});
    const [myIP, setMyIP] = useState({});
    const [myTop, setMyTop] = useState({});
    const [setTimeoutIds, setSetTimeoutIds] = useState([]);
    const [cannonTopBigImage, setCannonTopBigImage] = useState(cannonBigImage);
    const [cannonTopSmallImage, setCannonTopSmallImage] = useState(cannonSmallImage);
    const [cannonBottomBigImage, setCannonBottomBigImage] = useState(cannonBigImage);
    const [cannonBottomSmallImage, setCannonBottomSmallImage] = useState(cannonSmallImage);
    const handlePointsDrawerClick = () => {
        if (userType === 'rm' || userType === 'admins') {
            setIsPointsDrawerOpen(true);
            setShowBackdrop(true);
        }
    };

    const handlePointsDrawerClose = () => {
        setIsPointsDrawerOpen(false);
        setShowBackdrop(false);
    };
    const GetWarData = async () => {
        // console.log("here");
        let kId = kdData.k_id;
        let pointsDiff = 0;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, k_id: kId, war_id: war_id }),
        };
        // console.log(requestOptions);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-war-details', requestOptions);
        const data = await response.json();
        console.log(data, "war details1");
        if (data.status !== "success") {
            setError(true);
        }
        if (!(data.my_total == 0 && data.opp_total == 0)) {
            setMyper({ width: (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
            setOppper({ width: 100 - (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
        }
        pointsDiff = data.my_total - data.opp_total;
        if (pointsDiff < 0) {
            setAllPoints(`Your region trail by ${Math.abs(pointsDiff)}`);
        } else {
            setAllPoints(`Your region is ${pointsDiff} ahead.`);
        }
        // //hard code for testing
        // data.show_brahmastra_ani = true;
        // data.show_brahmastra_ani_rm = true;
        //  data.is_top_five.profile_pic = "";
        //  data.is_top_five = {"rank": 1,"points": 34625.4,"profile_pic": "https://pay1dms.s3.amazonaws.com/40649947_6_1_20220427125351.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI7HSXGL4VHBWFAMQ%2F20250106%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250106T064816Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=bf4039d4acfbdeb177221eb938bd387268b53e48608f6b097c3bf438ab5c4786","shopName": "Dhanak shop Pay1","name": "tester rockyeye","astra": "0","show_ani": true}
        //  data.is_top_five = {}
        // //hard code for testing end

        // normal distributor
        let my_kd_ip_point_total = data.my_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let my_kd_top_point_total = data.my_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let my_kd_ip_astra_total = data.my_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let my_kd_top_astra_total = data.my_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let myNormalDistributorData = {
            "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
            "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
        }
        console.log('normal dist')
        console.log(myNormalDistributorData);

        let opp_kd_ip_point_total = data.opp_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let opp_kd_top_point_total = data.opp_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let opp_kd_ip_astra_total = data.opp_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let opp_kd_top_astra_total = data.opp_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let oppNormalDistributorData = {
            "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
            "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
        }
        console.log('normal  opp dist')
        console.log(oppNormalDistributorData);

        setMyNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
                "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
            }
        ));
        setOppNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
                "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
            }
        ));

        // cannon data logic
        // Create the JSON object
        setCannonNames(data);
        // normal distributor end
        setCanonViewFlag(true);
        setArmyViewFlag(true);
        setPointsBreakup(points_data);
        setMyScoreBreakup(my_score);
        data.k_id = kId;
        let waf = data.war_end_time;
        const warStartTime = new Date(waf);
        localStorage.setItem("wet", warStartTime);

        // data.war_status = 3;
        setwarStartTime(warStartTime);
        setWarData(data);
        let userType = localStorage.getItem("user_type");
        setMyOppText(data.opp_kd_name);
        if (userType === 'rm' || userType === 'admins') {
            setMyKdText(data.my_kd_name);
            setExtra(<div className="row mb-3" >
                <div className="w-100 profile-flt-l">
                </div>
            </div>);
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <Link to={{
                                pathname: "/war-score-details",
                                state: [data, war_id]
                            }} className="w-100 profile-flt-l">

                                <div style={{ color: "white" }} >Distributor Details</div>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            {/*
			setMyScore(<div className="profile-war-data-bottom w-100 profile-flt-l center">
				<div className="ms-button" data-toggle="modal" data-target="#bottom_modal" >My Score</div>
			</div>);
			*/}
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <div className="w-100 profile-flt-l">My Points</div>
                        </div>
                    </div>
                </div>
            );
            setMyKdText("Your Region");
        }
        setMyScore(<div className="profile-war-data-bottom w-100 profile-flt-l center">
            <div className="ms-button-2" data-toggle="modal" data-target="#bottom_modal_2" >Region Details</div>
        </div>);

        const myB = [];
        const kdB = [];
        const mwB = [];
        var i = 0
        // data.my_pts = data.my_pts.sort((a, b) => b - a);
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach(function (serviceName) {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            const excludeServices = ["All Rounder"];
            if (!excludeServices.includes(data.all_services[serviceKey])) {
            // if (data.all_services[serviceKey] !== "All Rounder") {
                if (serviceName === 'Utility Bill Payment') {
                    serviceName = 'Bill Payment'
                } else if (serviceName === 'Daily Invest') {
                    serviceName = 'Daily Reserve'
                } else if (serviceName === 'Payment Gateway Credit Card') {
                serviceName = 'Payments';

                } else if (serviceName === 'Payment Gateway ( Partner Portal )') {
                    serviceName = 'Partner Portal';
                }

                if(serviceName === 'Saarthi Bonus' && !data.my_pts[serviceKey]>0){
                    return;
                }
                myB.push(
                    <div className="servicebox1dist" key={"myB_" + i}>
                        <div className="servicebox-innerdist">
                            <div className="servicename mt-1">
                                <img src={img} className="img-fluid img-service" alt="irctc" />
                                <span className="s1 s1sm">{serviceName}</span>
                            </div>
                            <div className="servicepoints d-flex align-items-center mt-1">
                                <img src="../images/BOR/points-coins.png" className="img-fluid img-service-point"
                                    alt="point" />
                                <span className="sp1">{data.my_pts[serviceKey]}</span>
                            </div>
                        </div>
                    </div>
                );
                i++;
            }
        });

        kdB.push(getRegionDetails(data));
        mwB.push(getMatchDetails(data));
        setMyBreakup(myB);
        setKdBreakup(kdB);
        setMwBreakup(mwB);

        localStorage.setItem("ws", 0);
        if (String(data.war_status) === '1') {
            localStorage.setItem("ws", 1);
        }
    }

    const getRegionDetails = (data) => {
        let kdB = [];
        let j = 0;
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_kd_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach((serviceName) => {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            // console.log("serviceName", serviceName, "index of ", data.all_services.indexOf(serviceName))
            let t1 = data.my_kd_pts[serviceKey];
            let t2 = data.opp_kd_pts[serviceKey];
            let tp1 = `50%`;
            let tp2 = `50%`;
            if (t1 !== 0 && t2 === 0) {
                tp1 = `100%`;
                tp2 = `0%`;
            } else if (t1 === 0 && t2 !== 0) {
                tp1 = `0%`;
                tp2 = `100%`;
            } else if (t1 !== 0 && t2 !== 0) {
                let tp = (t1 / (t1 + t2)) * 100;
                tp1 = tp + `%`;
                tp2 = (100 - tp) + `%`;
            }

            let serviceNameRt = data.all_services[serviceKey];

            if (serviceNameRt === 'Utility Bill Payment') {
                serviceNameRt = 'Bill Payment'
            } else if (serviceNameRt === 'Daily Invest') {
                serviceNameRt = 'Daily Reserve'
            } else if (serviceNameRt === 'Payment Gateway Credit Card') {
                serviceNameRt = 'Payments';

            } else if (serviceNameRt === 'Payment Gateway ( Partner Portal )') {
                serviceNameRt = 'Partner Portal';
            }
            kdB.push(
                <div className="regiondetailsboxdist" key={"oppB_" + j}>
                    <div className="heading-box pt-1 pb-1">
                        <img src={img} className="img-fluid" />
                        <p className="">{serviceNameRt}</p>
                    </div>
                    <div className="progress-wrapper">
                        <div className="progress-container">
                            <div className="progress-bar" style={{ "width": tp1 }} id="progress-bar"></div>
                        </div>
                        <div className="progress-text">
                            <span id="progress-value">{data.my_kd_pts[serviceKey]}</span>
                            <span>{data.opp_kd_pts[serviceKey]}</span>
                        </div>
                    </div>
                </div>
            );
            j++;
        });

        return kdB;
    }

    const ProgressBar = ({ initialValue, finalValue, myPoints, oppPoints }) => {
        const [width, setWidth] = useState(`50%`); // Start at 50%

        useEffect(() => {
            // Start animation after a small delay
            const timer = setTimeout(() => {
                setWidth(`${finalValue}%`);
            }, 4000);

            return () => clearTimeout(timer);
        }, [finalValue]);

        return (
            <div className="progress-wrapper">
                <div className="progress-container">
                    <div
                        className="progress-bar"
                        style={{
                            "width": width,
                            "transition": "width 3s ease-in-out" // Add smooth transition
                        }}
                        id="progress-bar"
                    ></div>
                </div>
                <div className="progress-text">
                    <span id="progress-value">{myPoints}</span>
                    <span>{oppPoints}</span>
                </div>
            </div>
        );
    };

    const getMatchDetails = (data) => {
        let mwB = [];
        let j = 0;
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_kd_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach((serviceName) => {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            // console.log("serviceName", serviceName, "index of ", data.all_services.indexOf(serviceName))
            let t1 = data.my_kd_pts[serviceKey];
            let t2 = data.opp_kd_pts[serviceKey];
            let tp1 = `50%`;
            let tp2 = `50%`;

            const myTotal = data.my_kd_pts.reduce((sum, x) => sum + x, 0);
            const oppTotal = data.opp_kd_pts.reduce((sum, x) => sum + x, 0);
            const isMatchTie = myTotal === oppTotal;
            const isMyWinner = myTotal > oppTotal;
            // decide left/right based on match winner
            const leftPts = isMatchTie ? t1 : (isMyWinner ? t1 : t2);
            const rightPts = isMatchTie ? t2 : (isMyWinner ? t2 : t1);
            // if (t1 !== 0 && t2 === 0) {
            //     tp1 = `100%`;
            //     tp2 = `0%`;
            // } else if (t1 === 0 && t2 !== 0) {
            //     tp1 = `0%`;
            //     tp2 = `100%`;
            // } else if (t1 !== 0 && t2 !== 0) {
            //     let tp = (t1 / (t1 + t2)) * 100;
            //     tp1 = tp + `%`;
            //     tp2 = (100 - tp) + `%`;
            // }
            // compute fill percentage from leftPts share
            const total = leftPts + rightPts;
            const finalPercentage = total === 0
                ? 50
                : (leftPts / total) * 100;
            // if (t1 !== 0 && t2 === 0) {
            //     finalPercentage = 100;
            // } else if (t1 === 0 && t2 !== 0) {
            //     finalPercentage = 0;
            // } else if (t1 !== 0 && t2 !== 0) {
            //     finalPercentage = (t1 / (t1 + t2)) * 100;
            // }

            let serviceNameRt = data.all_services[serviceKey];

            if (serviceNameRt === 'Utility Bill Payment') {
                serviceNameRt = 'Bill Payment'
            } else if (serviceNameRt === 'Daily Invest') {
                serviceNameRt = 'Daily Reserve'
            }
            mwB.push(
                <div className="regiondetailsboxdist" key={"oppB_" + j}>
                    <div className="heading-box pt-1 pb-1">
                        <img src={img} className="img-fluid" />
                        <p className="">{serviceNameRt}</p>
                    </div>
                    <ProgressBar
                        initialValue={50}
                        finalValue={finalPercentage}
                        myPoints={leftPts}
                        oppPoints={rightPts}
                    />
                </div>
            );
            j++;
        });

        return mwB;
    }

    const setCannonNames = (data) => {
        const excludeServices = ["All Rounder", "Bonus", "Dhanak Refurb", "Payment Gateway Credit Card"];
        const myServicePoints = data.all_services.reduce((acc, service, index) => {
            if (!excludeServices.includes(service)) {
                acc[service] = data.my_kd_pts[index];
            }
            return acc;
        }, {});

        const oppServicePoints = data.all_services.reduce((acc, service, index) => {
            if (!excludeServices.includes(service)) {
                acc[service] = data.opp_kd_pts[index];
            }
            return acc;
        }, {});
        let sortedMyServicePoints = Object.fromEntries(
            Object.entries(myServicePoints).sort(([, valueA], [, valueB]) => valueA - valueB)
        );
        let sortedOppServicePoints = Object.fromEntries(
            Object.entries(oppServicePoints).sort(([, value1], [, value2]) => value1 - value2) // Ascending order
        );
        setMyCannonData(Object.keys(sortedMyServicePoints));
        setOppCannonData(Object.keys(sortedOppServicePoints));
    }
    const GetWarDataSecond = async () => {
        // console.log("here");
        let kId = kdData.k_id;
        let pointsDiff = 0;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, k_id: kId, war_id: war_id }),
        };
        // console.log(requestOptions);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-war-details', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.status !== "success") {
            setError(true);
        }
        if (!(data.my_total == 0 && data.opp_total == 0)) {
            setMyper({ width: (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
            setOppper({ width: 100 - (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
        }
        pointsDiff = data.my_total - data.opp_total;
        if (pointsDiff < 0) {
            setAllPoints(`Your region trail by ${Math.abs(pointsDiff)}`);
        } else {
            setAllPoints(`Your region is ${pointsDiff} ahead.`);
        }
        //hard code for testing

        // data.show_brahmastra_ani = true;
        // data.show_brahmastra_ani_rm = true;
        // data.is_top_five.profile_pic = "";
        // data.is_top_five = {"rank": 1,"points": 34625.4,"profile_pic": "https://pay1dms.s3.amazonaws.com/40649947_6_1_20220427125351.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI7HSXGL4VHBWFAMQ%2F20250106%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250106T064816Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=bf4039d4acfbdeb177221eb938bd387268b53e48608f6b097c3bf438ab5c4786","shopName": "Dhanak shop Pay1","name": "tester rockyeye","astra": "0","show_ani": true}
        // data.is_top_five = {}

        //hard code for testing end

        // normal distributor
        let my_kd_ip_point_total = data.my_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let my_kd_top_point_total = data.my_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let my_kd_ip_astra_total = data.my_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) === 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let my_kd_top_astra_total = data.my_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) === 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let myNormalDistributorData = {
            "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
            "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
        }
        console.log('normal dist')
        console.log(myNormalDistributorData);

        let opp_kd_ip_point_total = data.opp_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let opp_kd_top_point_total = data.opp_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let opp_kd_ip_astra_total = data.opp_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let opp_kd_top_astra_total = data.opp_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let oppNormalDistributorData = {
            "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
            "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
        }
        console.log('normal  opp dist')
        console.log(oppNormalDistributorData);

        setMyNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
                "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
            }
        ));
        setOppNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
                "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
            }
        ));

        // Create the JSON object
        setCannonNames(data);


        // normal distributor end
        setCanonViewFlag(true);
        setArmyViewFlag(true);
        setPointsBreakup(points_data);
        setMyScoreBreakup(my_score);
        data.k_id = kId;
        let waf = data.war_end_time;
        const warStartTime = new Date(waf);
        localStorage.setItem("wet", warStartTime);

        setwarStartTime(warStartTime);
        setWarData(data);
        let userType = localStorage.getItem("user_type");
        setMyOppText(data.opp_kd_name);
        if (userType === 'rm' || userType === 'admins') {
            setMyKdText(data.my_kd_name);
            setExtra(<div className="row mb-3" >
                <div className="w-100 profile-flt-l">
                </div>
            </div>);
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <Link to={{
                                pathname: "/war-score-details",
                                state: [data, war_id]
                            }} className="w-100 profile-flt-l">

                                <div style={{ color: "white" }} >Distributor Details</div>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <div className="w-100 profile-flt-l">My Points</div>
                        </div>
                    </div>
                </div>
            );
            setMyKdText("Your Region");
        }
        setMyScore(<div className="profile-war-data-bottom w-100 profile-flt-l center">
            <div className="ms-button-2" data-toggle="modal" data-target="#bottom_modal_2" >Region Details</div>
        </div>);

        const myB = [];
        const kdB = [];
        // data.my_pts = data.my_pts.sort((a, b) => b - a);
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach(function (serviceName) {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            const excludeServices = ["All Rounder"];
            if (!excludeServices.includes(data.all_services[serviceKey])) {
            // if (data.all_services[serviceKey] !== "All Rounder") {
                if (serviceName === 'Utility Bill Payment') {
                    serviceName = 'Bill Payment'
                } else if (serviceName === 'Daily Invest') {
                    serviceName = 'Daily Reserve'
                }
                if(serviceName === 'Saarthi Bonus' && !data.my_pts[serviceKey]>0){
                    return;
                }
                myB.push(
                    <div className="servicebox1dist">
                        <div className="servicebox-innerdist">
                            <div className="servicename mt-1">
                                <img src={img} className="img-fluid img-service" alt="irctc" />
                                <span className="s1">{serviceName}</span>
                            </div>
                            <div className="servicepoints d-flex align-items-center mt-1">
                                <img src="../images/BOR/points-coins.png" className="img-fluid img-service-point"
                                    alt="point" />
                                <span className="sp1">{data.my_pts[serviceKey]}</span>
                            </div>
                        </div>
                    </div>
                );

            }
        });
        kdB.push(getRegionDetails(data));
        setMyBreakup(myB);
        setKdBreakup(kdB);

        localStorage.setItem("ws", 0);
        if (String(data.war_status) === '1') {
            localStorage.setItem("ws", 1);
        }
    }
    const [isHammer, setIsHammer] = useState(false);
    const [isOpponent, setIsOpponent] = useState(false);
    const hammerOpenModal = (ishammerflag, isOpponent) => {
        setIsHammer(ishammerflag);
        setIsOpponent(isOpponent);
    };

    const timeLeftToWar = () => {
        // console.log("here3");
        let wet = localStorage.getItem("wet");
        const difference = +new Date(wet) - +new Date();
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                // days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60))),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            return { 'no': 1 };
        }
        // console.log(timeLeft);
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(timeLeftToWar());
    useEffect(() => {
        GetWarData();
        const interval = setInterval(() => {
            let timeLt = timeLeftToWar();
            // console.log(timeLt);
            setTimeLeft(timeLt);
        }, 1000);
        return () => { clearInterval(interval) };
    }, []);

    useEffect(() => {
        const int = setInterval(() => {
            GetWarDataSecond()
            // }, 30 * 1000);
        }, 60 * 3 * 1000);
        return () => { clearInterval(int) };
    }, []);
    const imageAnimation = (warData, keyName, setTimeoutLimit) => {
        let bgAnimationTimeLimit = setTimeoutLimit + ((keyName == "opp_kd_top" || keyName == "my_kd_top") ? 1000 : 3000);
        let bgAnimationTimeResetLimit = bgAnimationTimeLimit + 1500;
        let bgStyle = {
            backgroundImage: `url(${pointsBGImageGif})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
        }
        let bgStyleImage = {
            backgroundImage: `url(${pointsBGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        if (warData && warData[keyName]) {
            warData[keyName].forEach((value, index) => {
                if (value.show_ani) {
                    setTimeout(() => {
                        switch (keyName) {
                            case "opp_kd_ip":
                                setOppIP(() => ({ [index]: "../images/BOR/impact-front-view-newgif.gif" }));
                                break;
                            case "opp_kd_top":
                                setOppTop(() => ({ [index]: "../images/BOR/top-distributors-front-viewnewgif.gif" }));
                                break;
                            case "my_kd_ip":
                                setMyIP(() => ({ [index]: "../images/BOR/Impact-back-viewnewgif.gif" }));
                                break;
                            case "my_kd_top":
                                setMyTop(() => ({ [index]: "../images/BOR/Top-Distributors-back-viewnewgif.gif" }));
                                break;
                        }
                    }, setTimeoutLimit);
                    setTimeout(() => {
                        if (keyName == "opp_kd_ip" || keyName == "opp_kd_top") {
                            setOppPointsBGStyle(bgStyle);
                            setMyPointsBGStyle(bgStyleImage);
                            setShowSpan(true);
                            setShowMySpan(false)

                            setshowOppPoints(value.points_added);
                            setshowMyPoints("");

                            setshowMyNumberOp(true);
                            setshowMyNumber(false);

                        } else if (keyName == "my_kd_ip" || keyName == "my_kd_top") {
                            setMyPointsBGStyle(bgStyle);
                            setOppPointsBGStyle(bgStyleImage);
                            setShowSpan(false);
                            setShowMySpan(true);

                            setshowOppPoints("");
                            setshowMyPoints(value.points_added);

                            setshowMyNumber(true);
                            setshowMyNumberOp(false);
                        }
                        // console.log('bgAnimationTimeLimit', bgAnimationTimeLimit)
                    }, bgAnimationTimeLimit);
                    setTimeout(() => {
                        setMyPointsBGStyle(bgStyleImage);
                        setOppPointsBGStyle(bgStyleImage);
                        setShowMySpan(false);
                        setShowSpan(false);

                        setshowOppPoints("");
                        setshowMyPoints("");

                        setshowMyNumber(false);
                        setshowMyNumberOp(false);

                        // console.log('bgAnimationTimeResetLimit', bgAnimationTimeResetLimit)
                    }, bgAnimationTimeResetLimit);


                    setTimeoutLimit = bgAnimationTimeResetLimit + 1000;
                    bgAnimationTimeLimit = setTimeoutLimit + ((keyName == "opp_kd_top" || keyName == "my_kd_top") ? 1000 : 3000);
                    bgAnimationTimeResetLimit = bgAnimationTimeLimit + 1500;
                }
                if (index === warData[keyName].length - 1) {
                    setTimeout(() => {
                        // Clear the state
                        setOppIP(() => ({}));
                        setOppTop(() => ({}));
                        setMyIP(() => ({}));
                        setMyTop(() => ({}));

                        setshowMyNumber(false);
                        setshowMyNumberOp(false);
                    }, setTimeoutLimit);
                }
            });

        }
    }
    const topCannonAnimation = () => {
        let bgStyle = {
            backgroundImage: `url(${pointsBGImageGif})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let bgStyleImage = {
            backgroundImage: `url(${pointsBGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let count = 0;
        let count1 = 0;
        let intervalId = setInterval(() => {
            setCannonTopBigImage(cannonBigGif);
            setCannonTopSmallImage(cannonSmallGif);
            if (count === 1) {
                clearInterval(intervalId);
                setCannonTopBigImage(cannonBigImage);
                setCannonTopSmallImage(cannonSmallImage);
                setOppPointsBGStyle(bgStyle);
                let intervalId1 = setInterval(() => {
                    if (count1 === 1) {
                        clearInterval(intervalId1);
                        setOppPointsBGStyle(bgStyleImage);
                    }
                    count1 += 1;
                }, 1000);
            }
            count += 1;
        }, 1500);
    }
    const BottomCannonAnimation = () => {
        let bgStyle = {
            backgroundImage: `url(${pointsBGImageGif})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let bgStyleImage = {
            backgroundImage: `url(${pointsBGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let countb = 0;
        let countb1 = 0;
        let intervalIdB = setInterval(() => {
            setCannonBottomBigImage(cannonBigGif);
            setCannonBottomSmallImage(cannonSmallGif);
            if (countb === 1) {
                clearInterval(intervalIdB);
                setCannonBottomBigImage(cannonBigImage);
                setCannonBottomSmallImage(cannonSmallImage);
                setMyPointsBGStyle(bgStyle);
                let intervalIdB1 = setInterval(() => {
                    if (countb1 === 1) {
                        clearInterval(intervalIdB1);
                        setMyPointsBGStyle(bgStyleImage);
                        setCanonViewFlag(false);
                    }
                    countb1 += 1;
                }, 1000);
            }
            countb += 1;
        }, 1500);
    }
    useEffect(() => {
        let setTimeoutLimit = 3000;
        console.log("isCanonView", isCanonView)
        if (isCanonView === false && armyViewFlag === true) {
            console.log("isCanonView 1", isCanonView)
            var oppKdIpAniCnt = 0;
            var oppKdTopAniCnt = 0;
            var myKdIpAniCnt = 0;
            warData["opp_kd_ip"].forEach((value, index) => {
                if (value.show_ani) {
                    oppKdIpAniCnt++;
                }
            });
            warData["opp_kd_top"].forEach((value, index) => {
                if (value.show_ani) {
                    oppKdTopAniCnt++;
                }
            });
            warData["my_kd_ip"].forEach((value, index) => {
                if (value.show_ani) {
                    myKdIpAniCnt++;
                }
            });
            var myKdTopAniCnt = 3;
            imageAnimation(warData, "opp_kd_ip", setTimeoutLimit);
            setTimeoutLimit = setTimeoutLimit + (3000 + 4500) * oppKdIpAniCnt;
            imageAnimation(warData, "opp_kd_top", setTimeoutLimit);
            setTimeoutLimit = setTimeoutLimit + (3000 + 2500) * oppKdTopAniCnt;
            imageAnimation(warData, "my_kd_ip", setTimeoutLimit);
            setTimeoutLimit = setTimeoutLimit + (3000 + 4500) * myKdIpAniCnt;
            imageAnimation(warData, "my_kd_top", setTimeoutLimit);
            let hideDivTemp = { "display": "none" };
            if (userType === 'rm' || userType === 'admins') {
                hideDivTemp = (warData.show_brahmastra_ani_rm) ? { "display": "block" } : { "display": "none" };
                setHideDiv(hideDivTemp)
            } else {
                hideDivTemp = (warData.show_brahmastra_ani) ? { "display": "block" } : { "display": "none" };
                setHideDiv(hideDivTemp);
            }
            setArmyViewFlag(false);
        } else {
            if (canonViewFlag === true) {
                setTimeout(() => topCannonAnimation(), 2000);
                setTimeout(() => BottomCannonAnimation(), 6000);
            }
        }
    }, [warData, userType, isCanonView]); // Trigger when `data` changes
    let playerModalPopup = "distributor-player-modal";
    if (userType === 'rm' || userType === 'admins') {
        playerModalPopup = "region-player-modal";
    }

    // Function to close the modal

    //Tooltip
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const toggleTextVisibility = () => {
        setIsTooltipVisible((prev) => !prev); // Toggle the visibility
    };


    const isVisible = warData.show_brahmastra_ani || warData.show_brahmastra_ani_rm;
    return (
        <>
            <Helmet
                link={[{
                    rel: "stylesheet",
                    href: "css/bor.css"
                }]}
            />


            <div className="warscore-maincontainer">
                <img
                    src={require("./../images/back.png").default}
                    className="img-fluid backIcon"
                    onClick={() => history.goBack()}
                    style={{
                        width: "1em",
                        cursor: "pointer",
                        position: "absolute",
                        margin: "1em",
                        zIndex: "10"

                    }}
                />
                {(warData.war_status === 3 || warData.war_status === 4) ? (
                    <MatchResult k_id={kdData.k_id} war_id={war_id} myKDName={warData.my_kd_name} myPoints={myBreakup} matchDetails={mwBreakup} war_data={warData} oppKDName={warData.opp_kd_name} myKDTotal={warData.my_total} oppKDTotal={warData.opp_total}></MatchResult>
                ) : (
                    <div className="warscore-innercontainerleft">
                        <Header isOpen={drawersOpen} oppKDName={warData.opp_kd_name} war_data={warData} />
                        {
                            drawersOpen && (
                                <div className="button-container" style={{
                                    display: isVisible ? 'block' : 'none'
                                }}>
                                    <button onClick={handleDrawerClose} id="toggle-drawers-btn">
                                        {allPoints}
                                    </button>
                                </div>
                            )
                        }
                        <div className="carousel-container">
                            <div className="carousel top-carousel" ref={topCarouselRef}>

                                <div className="carousel-items">
                                    <div className="army-box text-center">
                                        <img src="../images/BOR/army-frontview.gif" className="army img-fluid" alt="army standing here" />
                                    </div>
                                    <div className="apponent-container"><div className="apponent1">
                                        <div className="opponent1-container">
                                            <div className="row">
                                                <img src={oppIP["0"] || "../images/BOR/front-warriortop-new.png"} alt="Image 1" className="impact-front-view-arrow arrowfront1" />
                                                <img src={oppIP["1"] || "../images/BOR/front-warriortop-new.png"} alt="Image 2" className="impact-front-view-arrow arrowfront2" />
                                                <img src={oppIP["2"] || "../images/BOR/front-warriortop-new.png"} alt="Image 3" className="impact-front-view-arrow absimgtop" />
                                            </div>
                                        </div>
                                    </div>
                                        <div className="apponent1-t2">
                                            <div className="opponent1-container">
                                                <div className="row frontrow1row">
                                                    <img src={oppTop["0"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 1" className="impact-front-view-hammer hamfront1" />
                                                    <img src={oppTop["2"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 2" className="impact-front-view-hammer hamfront2" />
                                                    <img src={oppTop["1"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 3" className="impact-front-view-hammer  hamfront3" />

                                                </div>
                                                <div className="row frontrow2row">
                                                    <img src={oppTop["3"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 2" className="impact-front-view-hammer hamfront4" />
                                                    <img src={oppTop["4"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 3" className="impact-front-view-hammer hamfront5" />

                                                </div>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="carousel-items cannonapponentconD">
                                    <div className="apponent-container">
                                        <div className="apponent1canon d-flex oppcanon mt-5">
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>

                                                <img src={cannonTopBigImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[13]}</span></div>}

                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonTopSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[0]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonTopBigImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[12]}</span></div>}
                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonTopSmallImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[1]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonTopBigImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[11]}</span></div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="apponent1canon2 d-flex oppcanon mt-5">
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[4]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[5]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[6]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[7]}</span></div>}
                                        </div>
                                    </div>
                                    <div className="apponent1canon3 d-flex oppcanon mt-5">
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[10]}</span></div>}

                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[2]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[9]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[3]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[8]}</span></div>}
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>

                        {showBackdrop && (
                            <div
                                style={{
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    zIndex: 100,
                                }}
                            // onClick={() => {
                            //     setShowBackdrop(false);
                            // }}
                            ></div>
                        )}

                        <div ref={divRef} className="gradient-mainbox">
                            <div className="gradient-border pi1">
                                <div className="content" style={oppPointsBGStyle}>
                                    <img src="../images/BOR/points-coins.png" alt="PI" />
                                    <span className={showMyNumberOp === true ? "text-rolling" : ""}>{warData.opp_total.toLocaleString('en-In', { maximumFractionDigits: 0 })}</span>
                                    {showSpan && (<span className="text">+{showOppPoints}</span>)}

                                </div>
                            </div>
                            <div className="gradient-border pi2" onClick={handlePointsDrawerClick}>
                                <div className="content" style={myPointsBGStyle}>
                                    <img src="../images/BOR/points-coins.png" alt="PI" />
                                    <span className={showMyNumber === true ? "text-rolling" : ""}>{warData.my_total.toLocaleString('en-In', { maximumFractionDigits: 0 })}</span>
                                    {showMySpan && (<span className="text">+{showMyPoints}</span>)}
                                </div>
                            </div>
                        </div>

                        <div className="carousel-container-bottom">
                            <div className="carousel bottom-carousel" ref={bottomCarouselRef}>
                                <div className="carousel-items bottomcaruselitem1">

                                    <div className="apponent-container warrior-box">
                                        <div className="apponent1-t1">
                                            <div className="opponent1-container">
                                                <div className="row">
                                                    <img src={myIP["0"] || "../images/BOR/back-warriro-arrownew.png"} alt="Image 1" className="impact-back-view-arrow backarrow1" onClick={() => hammerOpenModal(false, false)} data-toggle="modal" data-target={"." + playerModalPopup} zindex="999" />
                                                    <img src={myIP["1"] || "../images/BOR/back-warriro-arrownew.png"} alt="Image 2" className="impact-back-view-arrow backarrow2" onClick={() => hammerOpenModal(false, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                                <div className="row backview2">
                                                    <img src={myIP["2"] || "../images/BOR/back-warriro-arrownew.png"} alt="Image 2" className="impact-back-view-arrow backarrow3" onClick={() => hammerOpenModal(false, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="apponent1-t2">
                                            <div className="opponent1-container">
                                                <div className="row backviewrow1">
                                                    <img src={myTop["0"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 1" className="impact-back-view-hammer backhammer1" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                    <img src={myTop["2"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 2" className="impact-back-view-hammer backhammer2" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                    <img src={myTop["1"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 3" className="impact-back-view-hammer backhammer3" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                                <div className="row backview2">
                                                    <img src={myTop["3"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 2" className="impact-back-view-hammer backhammer4" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                    <img src={myTop["4"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 3" className="impact-back-view-hammer backhammer5" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="army-box-bottom text-center">
                                        <img src="../images/BOR/army-backview.gif" className="army img-fluid" alt="army standing here" data-toggle="modal" data-target="#my-army-modal-lg" />
                                    </div>
                                </div>

                                <div className="carousel-items cannonitemcontainer">

                                    <div className="apponent-container">
                                        <div className="apponent1canonbottom d-flex mt-5">
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[10]}</span></div>}

                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[0]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[9]}</span></div>}
                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[1]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[8]}</span></div>}
                                            </div>
                                        </div>
                                        {/* <div className="apponent1-t2 oppcanon">
                                        <div className="frontcanon1">
                                        <img src={cannonBottomSmallImage} alt="Canon 1"
                                            className="canon-front-view img-fluid" />
                                            </div>
                                            <div className="frontcanonbig">
                                        <img src={cannonBottomBigImage} alt="Canon 2"
                                            className="canon-front-view img-fluid" />
                                            </div>
                                    </div> */}
                                    </div>
                                    <div className="apponent1canon2bottom d-flex mt-5">
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[4]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[5]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[6]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[7]}</span></div>}
                                        </div>
                                    </div>
                                    <div className="apponent1canon3bottom d-flex mt-5">
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomBigImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[13]}</span></div>}

                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[2]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomBigImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[12]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[3]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomBigImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[11]}</span></div>}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>


                        <Playersmodal data={warData} myKDName={warData.my_kd_name} />
                        <ArmyModal myNormalDistributorData={myNormalDistributor} oppNormalDistributorData={oppNormalDistributor} />
                        <DistributorProfileModal war_data={warData} isHammer={isHammer} isOpp={isOpponent} />
                        <Topdistributor war_data={warData} />
                        {/* <DistributorProfileModal /> */}

                        <div id="bottomDrawerRegion" className={`bottom-drawer-region ${isPointsDrawerOpen ? 'show' : ''}`} onClick={handlePointsDrawerClose}>
                            <div className="regionDetails">
                                <p>Region's Details
                                    <span className="close-btn1" onClick={handlePointsDrawerClose}><i class="fa fa-times" aria-hidden="true"></i></span>
                                </p>
                            </div>
                            {kdBreakup}
                        </div>
                        <Footer isOpen={drawersOpen} k_id={kdData.k_id} war_id={war_id} myKDName={warData.my_kd_name} myPoints={myBreakup} regionDetails={kdBreakup} war_data={warData} />
                    </div>
                )}


                <div className="warscore-innercontainerright">
                </div>
            </div>
        </>
    );


}

export default Bor;